// extracted by mini-css-extract-plugin
module.exports = {"container_footer":"style_container_footer__uLW7d","navigation_menu":"style_navigation_menu__4vA_P","box_menu":"style_box_menu__7VptQ","text_label":"style_text_label__CiC1s"};